import { PageTransition } from '@/constant/transition'
import Container from 'react-bootstrap/Container'
import { NavLink, useOutlet } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import clsx from 'clsx'
import Dropdown from 'react-bootstrap/Dropdown'
import { SettingsIcon } from 'lucide-react'
import { redirectToLabBaseAuthPage } from '@/util/auth'
import * as http from '@/util/http'
// import { getDefaultStore } from 'jotai'
// import { isLoggedInAtom } from '@/state'

export default function Profile() {
  const outlet = useOutlet()
  return (
    <>
      <div className="d-flex justify-content-between">
        <h2>マイページ</h2>
        <Dropdown drop="down-centered">
          <Dropdown.Toggle variant="secondary-outline">
            <SettingsIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={async () => {
                await http.del('/auth/v1/token')
                localStorage.setItem('isLoggedIn', 'false')
                // const store = getDefaultStore()
                // store.set(isLoggedInAtom, false)
                redirectToLabBaseAuthPage('intro', 'withdrawal')
              }}
            >
              サービス退会
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <p>プロフィール情報と興味あり企業リストを管理できます</p>
      <Container key="profile-tabs">
        <Row className={clsx('nav', 'nav-pills', 'mb-3')}>
          <Col className="nav-item">
            <NavLink
              to="/user/profile"
              end
              className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}
              state={{ direction: PageTransition.None }}
            >
              プロフィール
            </NavLink>
          </Col>
          <Col className="nav-item">
            <NavLink
              to="/user/profile/bookmarked-company"
              className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}
              state={{ direction: PageTransition.None }}
            >
              興味あり企業リスト
            </NavLink>
          </Col>
        </Row>
        <div>{outlet}</div>
      </Container>
    </>
  )
}
